import React from 'react'
import { motion, useScroll, useSpring } from 'framer-motion'

// Hairline at the very top of the viewport tracking read progress.
export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll()
  const scaleX = useSpring(scrollYProgress, { stiffness: 140, damping: 30, restDelta: 0.001 })

  return (
    <motion.div
      aria-hidden="true"
      style={{ scaleX }}
      className=" pointer-events-none fixed inset-x-0 top-0 z-[70] h-[2px] origin-left bg-mint-deep"
    />
  )
}
